export  const filters = [
    {
      filterType: "Approval Type",
      inputName: "status",
      options: [
        {
          name: "Approved",
          code: "Approved",
        },
        {
          name: "Pending",
          code: "Pending",
        },
        {
          name: "Rejected",
          code: "Rejected",
        },
      ],
    },
  ]